import React, { useEffect, useState } from "react";
import { Button, Menu, MenuProps, Progress, Tooltip } from "antd";
import { CloseOutlined, HomeOutlined, MenuOutlined } from "@ant-design/icons";
import "./main-nav-styles.scss";
import { useSelector } from "react-redux";
import { getAppIsMobile, getAuthIsLoading, getUserId } from "../../redux/selectors";
import { hideMenu } from "../../redux/actions";
import { useAppDispatch } from "../../redux/store/hooks";
import { useNavigate } from "react-router-dom";
import IconHome from "../icons/home";
import IconGraph from "../icons/graph";
import IconChart from "../icons/chart";
import IconCard from "../icons/card";
import IconSetting from "../icons/setting";
import IconFixer from "../icons/fixer";
import IconPerson from "../icons/person";
import IconDocs from "../icons/docs";
import Logout from "../Logout";

const MainNav: React.FC = () => {
  const navigate = useNavigate();
  const isMobile = useSelector(getAppIsMobile);
  //const menuIsOpen = useSelector(getAppMenuIsOpen);
  const userId = useSelector(getUserId);
  const dispatch = useAppDispatch();
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [bannerVisible, setBannerVisible] = useState(true);
  let type = localStorage.getItem("usertype");
  const [current, setCurrent] = useState("");
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    setCurrent(window.location.pathname.split("/")[1]);
    setMenuIsOpen(false);
  }, [window.location.pathname]);

  const closeMenu = (evt: any): void => {
    evt.stopPropagation();
    dispatch(hideMenu());
  };

  const handleClick: MenuProps["onClick"] = (e) => {
    setCurrent(e.key);
    navigate(`/${e.key}`);
  };

  const preventClick = (evt: any): void => {
    evt.stopPropagation();
  };

  const currentUser = localStorage.getItem("user");
  const isLoading = useSelector(getAuthIsLoading);

  const handleScroll = () => {
    const windowScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    const offsetHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    let scrolled: any = offsetHeight > 0 ? windowScroll / offsetHeight : 0;
    setPercent(scrolled * 100);
  };
  window.addEventListener("scroll", handleScroll);

  const items: any = [];

  type == "industry"
    ? items.push(
        {
          type: "divider",
        },
        {
          label: "Предприятие",
          key: "lk",
          icon: <IconHome />,
        },
        {
          label: "Входящие запросы",
          key: "requests",
          extra: <span className="counter">2</span>,
          icon: <IconChart />,
        },

        {
          label: "Банковские продукты",
          key: "banks",
          icon: <IconCard />,
        },

        /*{
          label: "Мой каталог товаров",
          key: "products",
        },*/

        {
          label: "Информационная аналитика",
          key: "media",
          icon: <IconGraph />,
        },
        {
          key: "g2",
          label: "Управление предприятием",
          type: "group",
          children: [
            {
              label: "Номенклатура",
              key: "history",
              icon: <IconSetting />,
            },
            {
              label: "Оборудование и сырьё",
              key: "equpment",
              icon: <IconFixer />,
            },
            {
              label: "Cтруктура и эксперты",
              key: "sources",
              icon: <IconPerson />,
            },
            {
              label: "Документы и сертификаты",
              key: "docs",
              icon: <IconDocs />,
            },

            /*{
              label: "Каталоги предприятий",
              key: "factory",
            },
            {
              label: "История поиска",
              key: "history",
            },*/
          ],
        },
        {
          key: "g2",
          label: "Управление закупками",
          type: "group",
          children: [
            {
              label: "Исходящие запросы",
              key: "requests",
              extra: <span className="counter">2</span>,
              icon: <IconChart />,
            },
          ],
        }
      )
    : type == "customer"
    ? items.push(
        {
          label: "Личный кабинет",
          key: "company",
        },
        {
          label: "Каталог продуктов",
          key: "catalog",
        },
        {
          label: "История поиска",
          key: "history",
        }
      )
    : items.push(
        {
          label: "Аналитика",
          key: "main",
        },
        {
          label: "Предприятия",
          key: "factory",
        },
        {
          label: "Эксперты",
          key: "sources",
        },
        {
          label: "Каталог продуктов",
          key: "catalog",
        },
        {
          label: "История поиска",
          key: "history",
        }
      );

  return (
    <>
      <div className="top-menu">
        <div className="main-nav__title " onClick={() => setMenuIsOpen(true)}>
          ПРОМЫШЛЕННОСТЬ
        </div>
        {window.location.pathname != "/" && currentUser && !isLoading && (
        <Logout />
      )}
        {/*
        <Progress
          percent={percent}
          showInfo={false}
          //status="exception"
          size="small"
  />*/}
      </div>
      <div
        onClick={closeMenu}
        className={menuIsOpen && isMobile ? "main-nav" : "null-length main-nav"}
      >
        <div className="main-nav__wrap" onClick={preventClick}>
          {menuIsOpen && isMobile && (
            <Button
              className="main-nav__btn"
              onClick={() => setMenuIsOpen(false)}
            >
              <CloseOutlined />
            </Button>
          )}

          <Menu
            onClick={handleClick}
            className={!menuIsOpen && isMobile ? "hide" : ""}
            items={items}
            selectedKeys={[current]}
            mode="inline"
          />
          {bannerVisible && type == "industry" && (
            <div className="banner">
              <CloseOutlined
                onClick={() => setBannerVisible(false)}
                className="close-icon"
              />
              <div className="flex">
                <div className="banner-icon">
                  <IconChart />
                </div>
                <p className="block-title" style={{ maxWidth: "210px" }}>
                  Конкурентная аналитика
                </p>
              </div>
              <div className="banner-content">
                <span>
                  Успешный бизнес - работать на шаг вперед конкурентов. Мы
                  предоставим информацию, которая даст преимущество
                </span>
              </div>
              <Button type="text">ЗАКАЗАТЬ АНАЛИЗ</Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MainNav;
